/**
 * @ngdoc service
 * @name mx.shell.NavigationItemConfigurationActionsService
 * @module mx.shell
 *
 * @description
 * Navigation Item Configuration Actions
 */

export class MxNavigationItemConfigurationActionsService {
	static $inject = [
		'mx.internationalization',
		'mx.SolutionBuilderAgent.SearchQueryService',
		'mx.shell.ContextService',
		'mx.SolutionBuilderAgent.SearchQuery',
		'mx.shell.SearchProviderService',
	];

	constructor(i18n, searchQueryService, contextService, SearchQuery, searchProviderService) {
		Object.assign(this, { i18n, searchQueryService, contextService, SearchQuery, searchProviderService });
	}

	getAddingChildItemAction(navigationItem) {
		let result;
		const that = this;
		if (navigationItem.configurable && navigationItem.routingItem?.name === 'searchPage') {
			const addChildAction = new mx.shell.Action(
				`add_child_filter_${navigationItem.name}`,
				this.i18n.get('solutionBuilderAgent.filters.addChildFilter'),
				'add_circle_outline'
			);
			addChildAction.controller = function () {
				return {
					execute() {
						that.searchQueryService.openFilterDialog(null, navigationItem.searchContext, null, true);
					},
				};
			};
			result = [addChildAction];
		}
		return result;
	}

	getFilterActions(navigationItem) {
		const filter = navigationItem.originFilterReference;
		const dataQuery = new this.SearchQuery(angular.extend(filter, { Widget: navigationItem.contentWidgetId }));

		if (!filter.CanEdit) {
			return [];
		}

		const editAction = new mx.shell.Action(`edit_filter_${filter.Id}`, this.i18n.get('solutionBuilderAgent.filters.editFilter'), 'edit');
		editAction.controller = this._getEditFilterActionController(dataQuery);

		const deleteAction = new mx.shell.Action(`delete_filter_${filter.Id}`, this.i18n.get('solutionBuilderAgent.filters.deleteFilter'), 'cancel');
		deleteAction.controller = this._getDeleteFilterActionController(dataQuery);

		const addAction = new mx.shell.Action(`add_child_filter_${filter.Id}`, this.i18n.get('solutionBuilderAgent.filters.addChildFilter'), 'add_circle_outline');
		addAction.controller = this._getAddFilterChildActionController(dataQuery);

		return [deleteAction, addAction, editAction];
	}

	_getDeleteFilterActionController(dataQuery) {
		const that = this;
		return function () {
			return {
				execute() {
					if (dataQuery) {
						that.searchQueryService.deleteFilter(dataQuery);
					}
				},
			};
		};
	}

	_getEditFilterActionController(dataQuery) {
		const that = this;
		return function () {
			return {
				execute() {
					that._setUIToken();
					that.searchQueryService.editFilter(dataQuery);
				},
			};
		};
	}

	_getAddFilterChildActionController(dataQuery) {
		const that = this;
		return function () {
			return {
				execute() {
					that._setUIToken();
					that.searchQueryService.addChildFilter(dataQuery);
				},
			};
		};
	}

	_setUIToken() {
		this.searchProviderService.uiToken = this.contextService.val('globalUiToken');
	}
}
